import Styles from './SearchModal.module.scss'
import { useRef, useState } from 'react'
import { RecentFiles } from './RecentFiles'
import { SearchConfigProps, SearchStateProps } from 'components/WorkspaceDashboardSearchBar/Types'
import Foco from 'react-foco'
import { SearchErrorCatcher } from './components/SearchErrorCatcher'
import { ConnectedSearchList as SearchList } from './components/SearchList/SearchList'
import { AlmanacFile, AlmanacFileSummary, SetState } from 'types'
import { ConnectedMobileTopBar as MobileTopBar } from './components/MobileTopBar/MobileTopBar'
import cx from 'classnames'

interface Props {
  placeholder: string
  onSuccess?: (data: { almanac_file: AlmanacFile | Omit<AlmanacFileSummary, 'ancestors'> }) => void
  initialValues?: {
    project?: AlmanacFile | null
    voiceId?: number
  }
  setSearchConfiguration: SetState<SearchConfigProps>
  searchConfiguration: SearchConfigProps
  setSearchState: SetState<SearchStateProps>
  searchState: SearchStateProps
  handleReset: () => void
}

export const SearchModalMobileContent = ({
  initialValues,
  onSuccess,
  placeholder,
  handleReset,
  setSearchConfiguration,
  searchConfiguration,
  setSearchState,
  searchState,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [searchValue, setSearchValue] = useState('')

  return (
    <>
      <Foco>
        <MobileTopBar
          placeholder={placeholder}
          initialValue={searchValue || searchState.query}
          initialValues={initialValues}
          onInputChange={(value: string) => setSearchValue(value.trim())}
          inputRef={inputRef}
        />
      </Foco>

      <div className={cx(Styles.mobileWrapper, { [Styles.withSearchResults]: searchValue.length > 0 })}>
        {searchValue.length === 0 ? (
          <RecentFiles />
        ) : (
          <div className={Styles.searchResults}>
            <SearchErrorCatcher />

            <div className={Styles.searchContainer}>
              <SearchList
                query={searchState.query}
                onReset={handleReset}
                searchConfiguration={searchConfiguration}
                setSearchConfiguration={setSearchConfiguration}
                setSearchState={setSearchState}
              />
            </div>
          </div>
        )}
      </div>
    </>
  )
}
